import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { GenericListState } from './types';

const initialState: GenericListState = {
  columns: [],
  rows: [],
  metaData: {
    loading: true,
    currentPage: 1,
    maxPages: 1,
    pageSize: 10,
    totalCount: 0,
  },
  filters: {},
  notification: { message: '', id: '' },
};

export const genericListSlice = createSlice({
  name: 'genericList',
  initialState,
  reducers: {
    setGenericListColumns(state, action: PayloadAction<any>) {
      state.columns = action.payload;
    },
    setGenericListRows(state, action: PayloadAction<Record<string, any>[]>) {
      state.rows = action.payload;
    },
    setGenericListMetaData(
      state,
      action: PayloadAction<{
        currentPage?: number;
        maxPages?: number;
        pageSize?: number;
        totalCount?: number;
        loading?: boolean;
      }>,
    ) {
      state.metaData = { ...state.metaData, ...action.payload };
    },
    setCurrentPageNumber(state, action: PayloadAction<number>) {
      state.metaData.currentPage = action.payload;
    },
    setGenericListMaxPage(state, action: PayloadAction<number>) {
      state.metaData.maxPages = action.payload;
    },
    setGenericListPageSize(state, action: PayloadAction<number>) {
      state.metaData.pageSize = action.payload;
    },
    setLoading(state, action: PayloadAction<{ loading: boolean }>) {
      state.metaData.loading = action.payload.loading;
    },
    setFilters(state, action: PayloadAction<Record<string, any>>) {
      state.filters = action.payload;
    },
    resetFilters(state) {
      state.filters = {};
    },
    setError(state, action: PayloadAction<{ message: string; id?: string }>) {
      state.notification = { ...action.payload, variant: 'error' };
    },
    clearNotification(state) {
      state.notification = {
        message: '',
        id: undefined,
        variant: undefined,
      };
    },
  },
});

export const {
  clearNotification,
  setLoading,
  setGenericListColumns,
  setGenericListRows,
  setCurrentPageNumber,
  setGenericListMetaData,
  setGenericListPageSize,
  setFilters,
  resetFilters,
  setError,
} = genericListSlice.actions;

const reducer = { genericList: genericListSlice.reducer };

export default reducer;
